export default __webpack_public_path__ + "Winterräder Cashback-Aktion 2026 - Teilnahmebedingungen_Stand 10-26.pdf";